export default {
  getSections: (state) => state.sections,
  getSectionsForm: (state) => state.sectionsForm,
  getSection: (state) => state.section,
};
